/* Shared confirmed cart writes for shade selectors, sets and gift choices.
   Never infer success from POST alone: Shopify may partially accept a request. */
(function () {
  'use strict';
  function quantities(cart) {
    const result = new Map();
    for (const item of (cart && cart.items) || []) {
      const id = String(item.variant_id || item.id);
      result.set(id, (result.get(id) || 0) + Number(item.quantity || 0));
    }
    return result;
  }

  function reconcileCart(drafts, before, after) {
    const previous = quantities(before);
    const current = quantities(after);
    const remaining = new Map();
    const deltas = new Map();
    let added = 0;
    let requested = 0;
    for (const [id, qty] of drafts) {
      const wanted = Number(qty);
      const delta = Math.max(0, (current.get(String(id)) || 0) - (previous.get(String(id)) || 0));
      const done = Math.min(wanted, delta);
      requested += wanted;
      added += done;
      if (done) deltas.set(String(id), done);
      if (wanted > done) remaining.set(String(id), wanted - done);
    }
    return { remaining, deltas, added, requested, complete: added === requested };
  }

  function usableSections(body) {
    const sections = body && body.sections;
    return sections && Object.values(sections).length && Object.values(sections).every((html) => typeof html === 'string' && html.length) ? sections : null;
  }


  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Reparația 7 (26 oct 2026): semnal „coșul lucrează” pentru butoane + cronometru de depanare
     (activ doar cu localStorage.pbCroTiming = '1'; scrie în consolă cât durează fiecare pas). */
  let marks = null;
  const mark = (name) => { if (marks) marks.push([name, Math.round(performance.now() - marks.t0)]); };
  async function add(requested, context = 'product', options = {}) {
    let timing = false;
    try { timing = localStorage.getItem('pbCroTiming') === '1'; } catch (_) {}
    marks = timing ? Object.assign([], { t0: performance.now() }) : null;
    document.dispatchEvent(new CustomEvent('pb-cro:cart-busy', { detail: { busy: true } }));
    try { return await addInner(requested, context, options); }
    finally {
      mark('gata');
      if (marks) { console.info('[PBCroCart] ms de la start:', JSON.stringify(marks)); marks = null; }
      document.dispatchEvent(new CustomEvent('pb-cro:cart-busy', { detail: { busy: false } }));
    }
  }
  async function addInner(requested, context, options) {
    const helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (!helper) return { unavailable: true };
      let result;
      try {
        result = await helper.withCartLock(async (standardEvent) => {
          const readCart = async () => {
            const response = await fetch(`${root()}cart.js`, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Cannot verify cart');
            return response.json();
          };
          mark('lacăt');
          const before = await readCart();
          mark('cart.js înainte');
          if (options.beforeAdd && !options.beforeAdd(before)) return { blocked: true };
          let response;
          let body;
          try {
            response = await fetch(`${root()}cart/add.js`, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [...requested].map(([id, quantity]) => ({ id, quantity, ...(options.properties ? { properties: options.properties } : {}) })),
                sections: helper.getSectionsToRender().map((section) => section.id),
                sections_url: window.location.pathname
              })
            });
            body = await response.json().catch(() => null);
            mark('cart/add.js (cu secțiuni)');
          } catch (_) { /* A network error can still follow a committed write. */ }
          let after;
          try { after = await readCart(); mark('cart.js după'); }
          catch (_) { return { uncertain: true }; }
          let rejected = false;
          if (options.finalize) {
            try {
              const final = await options.finalize(before, after, readCart);
              after = final.cart; rejected = final.rejected;
            } catch (_) { return { uncertain: true }; }
          }
          const outcome = reconcileCart(requested, before, after);
          standardEvent.settle(after, response && !response.ok ? helper.userErrorsFrom(body || {}) : []);
          outcome.rejected = rejected;
          if (outcome.added || rejected) {
            try { await helper.reRenderSections(rejected ? null : usableSections(body)); mark('reRenderSections'); }
            catch (_) { /* Cart snapshot confirms the write even if sections fail. */ }
            helper.currentItemCount = after.item_count;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            if (options.openCart !== false && window.Alpine && Alpine.store('xMiniCart')) Alpine.store('xMiniCart').openCart();
          }
          outcome.after = after;
          return outcome;
        });
      } catch (_) { result = { uncertain: true }; }
      mark('lacăt eliberat');
      if (result.added) {
        const confirmed = [...result.deltas].map(([id, quantity]) => ({ merchandiseId: id, quantity }));
        try {
          // withCartLock emits Eurus's existing standard cart event. Emit it only
          // after cart.js confirms the actual quantities, including a partial 422.
          await helper.withCartLock((standardEvent) => {
            standardEvent.settle(result.after);
          }, { type: 'shopify:cart:lines-update', action: 'add', context: context, lines: confirmed });
        } catch (_) { /* The cart write was already reconciled. */ }
        document.dispatchEvent(new CustomEvent('eurus:product:added', {
          detail: { product: [...result.deltas].map(([id, quantity]) => ({ variant_id: Number(id), quantity })) }
        }));
      }

    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { quantities, reconcileCart, usableSections };
  if (typeof window !== 'undefined') window.PBCroCart = { add, quantities, reconcileCart };
})();
